module.exports = __webpack_public_path__ + "static/img/TSZ.3e75560e.png";